import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import Brand from "./components/Brand";

function App() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "6285776282868";
    const message = encodeURIComponent(
      "Halo, saya ingin konsultasi mengenai service water heater saya."
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <div className="App">
      <Header onWhatsAppClick={handleWhatsAppClick} />
      <main>
        <Hero onWhatsAppClick={handleWhatsAppClick} />
        <Services />
		<div id="brands">
		  <Brand onWhatsAppClick={handleWhatsAppClick} />
		</div>
        <div id="proses">
          <Process />
        </div>
        <div id="testimoni">
          <Testimonials />
        </div>
        <div id="faq">
          <FAQ />
        </div>
        <CTA onWhatsAppClick={handleWhatsAppClick} />

      </main>
	  <div className="fixed bottom-0 right-0 m-8 z-[1000]">
        <button
          onClick={handleWhatsAppClick}
          className="bg-green-500 hover:bg-green-600 text-white font-bold p-4 rounded-full shadow-lg"
        >
          <img
			src="/whatsapp-icon.svg"
			alt="WhatsApp"
			className="w-8 h-8"
		  />
        </button>
      </div>
      <Footer />
    </div>
  );
}

export default App;
